import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { SectionsModule } from './sections/sections.module';
import { ComponentsModule } from './components/components.module';
import { ExamplesModule } from './examples/examples.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { SafeHtmlPipe } from './shared/pipes/safe-html.pipe';

import { PresentationModule } from './presentation/presentation.module';
import { FooterComponent } from './shared/footer/footer.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { EventsComponent } from './pages/events/events.component';
import { NewsComponent } from './pages/news/news.component';
import { SupportComponent } from './pages/support/support.component';
import { LoginComponent } from './pages/login/login.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SystemStatusComponent } from './pages/system-status/system-status.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { InfoPopiComponent } from './pages/info-popi/info-popi.component';
import { InfoNewsComponent } from './pages/info-news/info-news.component';
import { InfoBlogComponent } from './pages/info-blog/info-blog.component';
import { InfoNewsDetailComponent } from './pages/info-news-detail/info-news-detail.component';
import { GoogleMapsModule } from '@angular/google-maps'

import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { DeveloperStatusComponent } from './pages/developer-status/developer-status.component';
import { Page404Component } from './pages/page404/page404.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ReferralsComponent } from './pages/referrals/referrals.component';
import { DiyStarterComponent } from './pages/packages/diy-starter/diy-starter.component';
import { DiyComponent } from './pages/packages/diy/diy.component';
import { FullHouseComponent } from './pages/packages/full-house/full-house.component';
import { EBuroComponent } from './pages/packages/e-buro/e-buro.component';
import { GetAQuoteComponent } from './pages/get-a-quote/get-a-quote.component';
import { FeaturesComponent } from './pages/features/features.component';
import { TestimonialDetailComponent } from './pages/testimonial-detail/testimonial-detail.component';


const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname // or 'your.domain.com' 
  },
  palette: {
    popup: {
      background: '#f26a36',
      text: '#ffffff',
    },
    button: {
      background: '#184685'
    }
  },
  theme: 'classic',
  type: 'opt-out',
  content: {
    message: 'We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies.',
    dismiss: 'Got it!',
    deny: 'Deny cookies',
    link: 'Learn more',
    href: '/tandc#cookies',
    policy: 'Cookie Policy'
  }
};

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    ContactUsComponent,
    EventsComponent,
    NewsComponent,
    SupportComponent,
    LoginComponent,
    ResetPasswordComponent,
    SystemStatusComponent,
    InfoPopiComponent,
    InfoNewsComponent,
    InfoBlogComponent,
    InfoNewsDetailComponent,
    TermsAndConditionsComponent,
    DeveloperStatusComponent,
    Page404Component,
    PrivacyPolicyComponent,
    ReferralsComponent,

    DiyStarterComponent,
    DiyComponent,
    FullHouseComponent,
    EBuroComponent,
    GetAQuoteComponent,
    FeaturesComponent,
    TestimonialDetailComponent,
    SafeHtmlPipe

  ],
  imports: [
    NgcCookieConsentModule.forRoot(cookieConfig),
    RecaptchaV3Module,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgbModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    PresentationModule,
    SectionsModule,
    ComponentsModule,
    ExamplesModule,
    HttpClientModule,
    GoogleMapsModule,
    GoogleTagManagerModule.forRoot({
      id: environment.google.YOUR_GTM_ID,
    })
  ],
  providers: [{
    provide: RECAPTCHA_V3_SITE_KEY,
    useValue: environment.recaptcha.siteKey,
  }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
